import React from 'react'
import { connect } from 'react-redux'

import { footerConnection } from "sheets/selectors/column-selectors"
import { StyledFooterCell } from  "sheets/components/style"

/**
 * Renders the footer that displays various aggregate Math functions for the columns
 *
 * @param { string } footerLabel
 * @param { boolean } shouldDisplayMathBar
 */
export const MathFooter = ({ footerLabel, shouldDisplayMathBar }) => {
    return (
        <span data-cy="math-footer">
            {
                (shouldDisplayMathBar) ? (
                    <StyledFooterCell>
                        { footerLabel ? footerLabel : "" }
                    </StyledFooterCell>
                ) : null
            }
        </span>
    )
}

export default connect((props, state) => footerConnection(props, state))(MathFooter)

